// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1dgPa","footer":"ModalError_footer__NRwol"};